exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-active[data-v-cb655b92]{outline:1px dashed #dcdfe6}.inline-box[data-v-cb655b92]{display:inline-block;margin-right:5px;margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-cb655b92","scoped":true,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ComponentBox/ComponentBox.vue
// module id = 101
// module chunks = 0